import React, { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';
import * as yup from 'yup';

import { REQUIRED_TEXT } from '@/common/constants';
import { Dependent } from '@/modules/employee/employee.types';
import DependentsAge from '@/modules/employee/Employee/Dependents/hooks/DependentsAge';
import colors from '@/styles/colors';

interface Params {
  holderList: Dependent[];
  defaultType: string | null;
}

export const useTypeForm = (params: Params) =>
  useMemo(
    (): Field[] => [
      {
        name: 'type',
        type: FieldTypes.Dropdown,
        label: 'Select dependent',
        placeholder: 'None',
        validator: yup.string().required(REQUIRED_TEXT),
        defaultValue: params.defaultType ? params.defaultType : '',
        singleMode: true,
        options: [
          {
            key: 'new',
            value: 'new',
            title: 'Create New Dependent',
            divide: true,
            textStyle: {
              color: colors.textAccent,
            },
          },
          ...params.holderList.map((holder) => ({
            key: holder.dependentId,
            value: holder.dependentId,
            title: holder.fullName,
            node: <DependentsAge fullName={holder?.fullName} birthOn={holder?.birthOn || ''} />,
          })),
        ],
      },
    ],
    [params]
  );
